export function setInfoToLinks(linkArr, href, content = null, targetBlank = true) {
    if(linkArr && linkArr.length) {
        linkArr.forEach(link => {
            link.href = href;
            if (content) { link.innerHTML = content }
            if (targetBlank) { link.target = "_blank" }
        })
    }
}